import React from 'react'
import { Button, Tab, Tabs } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import { PhotovoltaicTrackerModel } from 'src/Libs/installation-statement/models/photovoltaic'
import { makeStyles } from 'tss-react/mui'
import PhotovoltaicTabIcon from './PhotovoltaicTabIcon'
import { MAXIMUM_NUMBER_OF_TRACKERS } from './photovoltaic.constants'

interface Props {
  tabs: PhotovoltaicTrackerModel[]
  addTracker: () => void
  activeTab: number
  setActiveTab: (tabIndex: number) => void
}

/**
 * Displays the tabs for the wizard step "photovoltaic"
 * Tabs can be added dynamically and represent a tracker
 */

const useStyles = makeStyles()(theme => ({
  tabs: {
    marginLeft: 15,
    borderBottom: `1px solid ${theme.palette.background.paperBorder}`,
  },
  tab: {
    color: theme.palette.text.header,
    '&.Mui-selected': {
      color: theme.palette.primary.main,
    },
    '&:first-of-type': {
      marginLeft: 0,
    },
  },
}))

const PhotovoltaicTabs: React.FC<Props> = ({ tabs, addTracker, activeTab, setActiveTab }) => {
  const { t } = useCustomTranslation()
  const addButtonDisabled = tabs.length >= MAXIMUM_NUMBER_OF_TRACKERS
  const { classes } = useStyles()

  return (
    <Tabs className={classes.tabs} value={activeTab} onChange={(_, tabIndex) => setActiveTab(tabIndex)} variant="scrollable">
      {tabs.map((tracker, index) => (
        <Tab
          className={classes.tab}
          key={`photovoltaic-tab-${index}`}
          label={`${t('installation-statement.photovoltaic.tab.title')} ${index + 1}`}
          icon={<PhotovoltaicTabIcon tabData={tracker} index={index} isInactive={index !== activeTab} />}
          iconPosition={'end'}
        />
      ))}
      <OptionalTooltipWrapper hasTooltip={addButtonDisabled} titleKey={'installation-statement.photovoltaic.tab.disabled-add-tracker-tooltip'}>
        <Button variant="text" onClick={addTracker} color="inherit" disabled={addButtonDisabled}>
          {t('installation-statement.photovoltaic.tab.add')}
        </Button>
      </OptionalTooltipWrapper>
    </Tabs>
  )
}

export default PhotovoltaicTabs
